import Api from 'api'

const config = {
  baseURL: '/api/app/v2/',
}
const api = new Api(config)

api.fetchChart = ({ externalId, network, ...rest }) =>
  api.get(`${network}/statistics/accounts/${externalId}/dates`, { ...rest })

api.fetchAccountCampaigns = ({ externalId, network, ...rest }) =>
  api.get(`${network}/statistics/accounts/${externalId}/campaigns`, { ...rest })

//@TODO add but patch. need to check contract
api.add = ({ id, network, ...rest }) => api.patch(`/${network}/accounts/${id}`, { ...rest })

api.fetchAccountById = ({ network, externalId }) => api.get(`/${network}/accounts/${externalId}`)

export default api
